import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  mt8: {
    marginTop: 8,
  },
  currency: {
    textTransform: 'uppercase',
    color: '#878787',
    fontSize: 15,
  },
  attentionText: {
    fontSize: 16,
  },
  icon: {
    fontSize: 24,
    marginRight: 16,
  },
  title: {
    textTransform: 'uppercase',
    color: '#5e5e5e',
    fontSize: 19,
    fontWeight: 700,
  },
  alert: {
    backgroundColor: '#ffedb8',
    borderRadius: 4,
    padding: 12,
    display: 'flex',
    alignItems: 'center',
  },
}));
